import React, { useEffect, useState, useRef, } from 'react';
import { Modal, Button, } from 'react-bootstrap';
import Cookie from 'universal-cookie';
import 'bootstrap/dist/css/bootstrap.min.css';
import './login.css'
import { baseUrl_api, apiUrl_api, baseUrl, } from './url.jsx';

function Profile({ uid, onModalClose }) {
    const cookie = new Cookie();
    const [show, setShow] = useState(true);
    const [total, setTotal] = useState(0);
    const [used, setUsed] = useState(0);
    const [detail, setDetail] = useState([]);
    const [proEnd, setProEnd] = useState(null);
    const [enterpriseEnd, setEnterpriseEnd] = useState(null);

    const handleClose = (user) => {
        onModalClose(user);
    };

    useEffect (() => {
        if (uid) {
            const bodyData = { uid: uid };
            fetch(baseUrl_api + "/get_meeting_used", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(bodyData),
                keepalive: true,
            })
            .then(response => response.json())
            .then(data => {
                setTotal(data.total);
                setUsed(data.used);
                setDetail(data.detail);
                setProEnd(data.proEnd);
                setEnterpriseEnd(data.entEnd);
            })
            .catch(error => {
                console.error(error);
            });
        }
    }, [])

    const handleLgoout = () => {
        console.log(cookie);
        cookie.remove('login-info');
        console.log(cookie);

        const bodyData = {url: baseUrl};
        fetch(apiUrl_api + "/logout", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(bodyData),
            keepalive: true,
        })

        fetch(baseUrl_api + "/logout", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            keepalive: true,
        })

        onModalClose(true);     // 传递注销信号
        setShow(false);
    };

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const listItems = detail ? detail.map((item) => {
        const date = new Date(item.CheckTime);
        const localTime = date.toLocaleString("en-US", {
            timeZone,
            hour12: false,
            hour12: false,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
        }).replace(/,/g,"").replace(/\//g, "-");

        const [dateStr, timeStr] = localTime.split(" ");
        const [month, day, year] = dateStr.split("-");
        const formattedDate = `${year}-${month}-${day}`;

        return (
            <li className="list-group-item d-flex justify-content-between lh-sm"
                key={item.CheckTime}
            >
                <div>
                    <h6 className="my-0">{ formattedDate + ' , '+ timeStr }</h6>
                    {/* <small className="text-body-secondary">{timeStr}</small> */}
                </div>
                <span className="text-body-secondary">{ item.UsedMinutes }</span>
            </li>
        );
    }): [];

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header className="justify-content-center bg-light">
                <div className="profile modal-gx-n">
                    <div className="profile-img text-primary rounded-top-xl"></div>
                    <div className="profile-body">
                        <div className="avatar avatar-xl">
                            <span className="avatar-text avatar-text-user">
                                <i className="bi bi-person icon-1-5x"></i>
                            </span>
                        </div>
                    </div>
                    <h6>{ enterpriseEnd && "Enterprise：" + enterpriseEnd + " 到期" }</h6>
                    <h6 variant='outline-secondary'>{ proEnd && "Pro：" + proEnd + " 到期" }</h6>
                    <hr className="my-3"></hr>
                    <h6>{ total > 0 && "您的每日可用时间：" + total +" 分钟" }</h6>
                    <h6>{ total > 0 && "您今日已使用时间：" + used +" 分钟" }</h6>
                </div>
            </Modal.Header>
            <Modal.Body className="justify-content-center bg-light">                
                <div className="container py-8"  style={{ height: "300px", overflow: "auto" }}>                    
                    <ul className="list-group mb-3">
                        {listItems}
                    </ul>
                </div>
                <hr className="my-3"></hr>
                <div className="container d-flex justify-content-center py-8">
                    <Button
                        variant="outline-success"
                        className="py-2 mb-2 m-2 btn-outline-secondary rounded-3"
                        onClick={handleLgoout}
                    >
                        <i className="bi bi-person-dash"></i>    Logout
                    </Button>
                   
                </div>
            </Modal.Body>
        </Modal>
    );
        
}

export default Profile;
